import { authCid } from "../Api/ApiUrl";
import { storeArq } from "correos-arq-utils";
import axios from "axios";

export const logout = async () => {
  try {
    await axios.post(
      authCid.cancelToken,
      { idToken: storeArq.data.auth.idToken },
      {
        headers: {
          ApplicationOid: window._env_.REACT_APP_CLIENT_ID_C_ID,
        },
      }
    );

    storeArq.delete();
    window.location.href = "/";
  } catch (err) {
    console.error("logoutUtils", err);
    storeArq.delete();
    window.location.href = "/";
  }
};
